/* CUSTOM (pawarts): PDP A/B "arm" bucketing + cart-attribute stamp.
   Always shows the value-ladder UI; only assigns a stable 50/50 arm and writes
   it to a cart attribute (paw_arm) so it lands on the order for contribution
   measurement. See ../CUSTOMIZATIONS.md #12. */
(function () {
  var COOKIE = 'paw_arm';
  var ARMS = ['A', 'B'];

  function readCookie(name) {
    var m = document.cookie.match('(?:^|; )' + name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1') + '=([^;]*)');
    return m ? decodeURIComponent(m[1]) : null;
  }

  function writeCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + encodeURIComponent(value) +
      '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }

  // 1) Resolve a stable arm (assign once, persist for the test lifetime).
  var arm = readCookie(COOKIE);
  if (arm !== 'A' && arm !== 'B') {
    arm = ARMS[Math.random() < 0.5 ? 0 : 1];
    writeCookie(COOKIE, arm, 365);
  }
  document.documentElement.setAttribute('data-paw-arm', arm);

  // 2) Stamp the arm onto the cart once per session (lands on the order as a
  //    note attribute the export pipeline can read). Guard against re-posting.
  try {
    if (sessionStorage.getItem('paw_arm_synced') === arm) return;
  } catch (e) {}

  var base = (window.theme && theme.routes && theme.routes.cart_update_url) || '/cart/update';
  fetch(base + '.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ attributes: { paw_arm: arm } })
  }).then(function () {
    try { sessionStorage.setItem('paw_arm_synced', arm); } catch (e) {}
  }).catch(function () {});
})();
